var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown-menu',{attrs:{"visible-arrow":_vm.visibleArrow,"arrow-offset":_vm.arrowOffset}},[_c('div',{staticClass:"dropdown-menu-outer"},[_c('div',{staticClass:"dropdown-menu-inner",style:({
        maxHeight: _vm.maxHeight
      })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }